// Local copy of @mobilize/shared's slugify (packages/shared/src/slugify.ts),
// inlined here to keep signup-web's Docker build stage free of workspace
// (@mobilize/*) deps — that stage builds from `deps` alone and does NOT compile
// packages/shared, so importing the workspace package would fail Vite's `import`
// export-condition resolution to a non-existent dist/. Keep in sync with the
// shared source. See docs/superpowers/plans/2026-07-04-tenant-subdomains.md Task 12.
/**
 * Convert an arbitrary display name into a URL-safe org slug. Pure function:
 * lowercases, strips diacritics + non-alphanumerics, collapses runs to single
 * hyphens, trims leading/trailing hyphens, caps at 48 chars. Empty/garbage
 * input falls back to 'org' so a slug is always produced.
 */
export function slugify(input: string): string {
  return (
    input
      .normalize('NFKD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 48) || 'org'
  );
}

/**
 * Like slugify(), but returns '' instead of the 'org' placeholder when the
 * input has no Latin letters or digits to build an address from (for example a
 * Japanese community name). Callers use '' to ask the user for an address
 * explicitly rather than silently publishing a generic fallback.
 */
export function tryAutoSlug(input: string): string {
  return /[a-z0-9]/.test(
    input
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase(),
  )
    ? slugify(input)
    : '';
}
